export { makePageClassificationService } from './pageClassification';
export { makePageContentService } from './pageContent';
export { pageTemplates } from './pageClassification';

export type {
  AttributeTypeClassificationRule,
  CatchAllClassificationRule,
  ClassificationRules,
  ClassifyPage,
  ContentModuleSlotType,
  DomainKeyClassificationRule,
  PageClassification,
  PageClassificationService,
  PageTemplate,
  PageTemplateName,
  SlugClassificationRule,
} from './pageClassification';
export type { PageContentService, PageAncestorContent } from './pageContent';
